module.exports = __webpack_public_path__ + "img/guanica.84c7c041.jpg";